export function LogoIcon({ className = "w-9 h-9", idSuffix = "def", isLight = false }) {
  return (
    <img 
      src="https://assets.auxodev.dk/assets/48b457c4-b6b2-4d62-b92b-6229aa267ddf/medicinsk-play-cross-logo.png" 
      alt="Health4media logo" 
      className={`${className} object-contain`}
    />
  );
}

export default function Logo({ 
  variant = 'default', // 'default' (dark text), 'light' (white text on dark), 'icon-only'
  size = 'md', // 'sm', 'md', 'lg'
  className = ''
}) {
  const sizeClasses = {
    sm: {
      icon: 'w-7 h-7',
      text: 'text-lg'
    },
    md: {
      icon: 'w-8 h-8 sm:w-9 sm:h-9',
      text: 'text-xl sm:text-2xl min-[1200px]:text-[25px]'
    },
    lg: {
      icon: 'w-10 h-10 sm:w-11 sm:h-11',
      text: 'text-2xl sm:text-3xl'
    }
  };

  const currentSize = sizeClasses[size] || sizeClasses.md;
  const isLight = variant === 'light';

  if (variant === 'icon-only') {
    return <LogoIcon className={`${currentSize.icon} ${className}`} idSuffix={`icon-${size}`} isLight={isLight} />;
  }

  return (
    <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
      <div className="shrink-0 transition-transform duration-200 group-hover:scale-105">
        <LogoIcon className={currentSize.icon} idSuffix={variant} isLight={isLight} />
      </div>
      <div className="flex flex-col">
        <span className={`font-extrabold tracking-tight leading-none ${isLight ? 'text-white' : 'text-slate-900'} ${currentSize.text}`}>
          Health4media
        </span>
      </div>
    </div>
  );
}
